import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'
import {
  CreateCoordinatorModel,
  EditCoordinatorModel,
  SearchCoordinatorModel,
  ToggleCoordinatorModel,
} from '../../models/coordinator.model'

@Injectable({
  providedIn: 'root',
})
export class CoordinatorService {
  private baseUrl = environment.baseUrl
  private resource = 'Coordenador'

  constructor(private httpClient: HttpClient) {}

  public listCoordenador(ativo?: string): Observable<ResponseRequestModel> {
    const query = ativo ? `?ativo=${ativo}` : ''
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall${query}`,
    )
  }

  public listPagedCoordenador(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedCoordenador(
    page: number,
    rows = 15,
    model: SearchCoordinatorModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public getCoordenadorById(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public createCoordenador(
    model: CreateCoordinatorModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editCoordenador(
    model: EditCoordinatorModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public toggleCoordenador(
    model: ToggleCoordinatorModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/toggle`,
      model,
    )
  }
}
